export const formFields = [  
    {  
      section: 'Screen Layout',  
      name: 'aosAccumOvrdSchedule',  
      label: 'Schedule',  
      fieldLabel: 'AOS Accum Ovrd Schedule',  
      type: 'text',  
      options: {  
        required: { value: true, message: 'Value required' },  
        maxLength: { value: 15, message: 'Cannot exceed more than 15 characters' },  
      },  
      fieldNature: 'Add: Editable, Change: Read-only, View: Read-only',  
      position: [5, 1],  
    },  
    {  
      section: 'Screen Layout',  
      name: 'aosAccumOvrdScdeDesc',  
      label: 'Description',  
      fieldLabel: 'AOS Accum Ovrd Scde Desc',  
      type: 'text',  
      options: {  
        required: { value: true, message: 'Value required' },  
        maxLength: { value: 25, message: 'Cannot exceed more than 25 characters' },  
      },  
      fieldNature: 'Add: Editable, Change: Editable, View: Read-only',  
      position: [6, 1],  
    },  
    {  
      section: 'Screen Layout',  
      name: 'aosDispOutdatedRcds',  
      label: 'Display',  
      fieldLabel: 'DSC Disp Outdated Rcds?',  
      type: 'dropdown',  
      dropdownCondition: '*ALL values',  
      options: {},  
      fieldNature: 'Add: Non-Display, Change: Editable, View: Read-only',  
      position: [7, 1],  
    },  
    {  
      section: 'Screen Layout',  
      name: 'aosAccumOvrdScdeType',  
      label: 'Type',  
      fieldLabel: 'AOS Accum Ovrd Scde Type',  
      type: 'dropdown',  
      dropdownCondition: '*ALL values',  
      options: {  
        required: { value: true, message: 'Value required' },  
        maxLength: { value: 1, message: 'Cannot exceed more than 1 characters' },  
      },  
      fieldNature: 'Add: Editable, Change: Read-only, View: Read-only',  
      position: [8, 1],  
    },  
    {  
      section: 'Audit Fields',  
      name: 'addDate',  
      label: 'Added',  
      fieldLabel: 'ADD Date',  
      type: 'date',  
      options: {},  
      fieldNature: 'Add: Non-Display, Change: Read-only, View: Read-only',  
      position: [9, 1],  
    },  
    {  
      section: 'Audit Fields',  
      name: 'chgDate',  
      label: 'Changed',  
      fieldLabel: 'CHG Date',  
      type: 'date',  
      options: {},  
      fieldNature: 'Add: Non-Display, Change: Read-only, View: Read-only',  
      position: [9, 20],  
    },  
    {  
      section: 'Audit Fields',  
      name: 'chgUserName',  
      label: 'User',  
      fieldLabel: 'CHG User Name',  
      type: 'text',  
      options: {  
        maxLength: { value: 10, message: 'Cannot exceed more than 10 characters' },  
      },  
      fieldNature: 'Add: Non-Display, Change: Read-only, View: Read-only',  
      position: [9, 30],  
    },  
    {  
      section: 'Audit Fields',  
      name: 'noteExists',  
      label: 'Note Exists',  
      fieldLabel: 'Note Existence Status',  
      type: 'text',  
      options: {},  
      fieldNature: 'Add: Non-Display, Change: Read-only, View: Read-only',  
      position: [9, 40],  
    },  
  ].sort((a, b) => (a.position[0] - b.position[0]) || (a.position[1] - b.position[1]));  